export const KEYS = {
  COPY_MESSAGE_TIMEOUT: 2000,
};

export const LABELS = {
  COPY_MESSAGE: ['components.dataTable.cells.copy.copy', 'Copied!'],
  ACTION_MENU_TITLE: ['components.dataTable.cells.actionMenu.title', 'Actions'],
};
